import React, { useState } from "react"
import { IHeaderParams, GridApi } from "ag-grid-community"
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material"
import pin_icon from "../../../assets/images/pin_icon.svg"
import "../agGridTable.scss"

interface CustomHeaderProps<T = any> extends IHeaderParams<T> {
    customIcon?: string
}

const CustomHeader = <T,>(props: CustomHeaderProps<T>) => {
    
    const { displayName, column, api: rawApi, customIcon } = props
    const colId = column.getColId()
    const isPinned = column.getPinned() === "left"

    const api = rawApi as GridApi

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleMenuClick = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)
    const handleMenuClose = () => setAnchorEl(null)

    const allColumns = api.getAllDisplayedColumns()
    const colIndex = allColumns.findIndex(col => col.getColId() === colId)
    const currentCol = allColumns.find(col => col.getColId() === colId)
    
    const sortAsc = () => {
        api.applyColumnState({
            state: [{ colId, sort: "asc" }],
            applyOrder: false,
        })
        handleMenuClose()
    }

    const sortDesc = () => {
        api.applyColumnState({
            state: [{ colId, sort: "desc" }],
            applyOrder: false,
        })
        handleMenuClose()
    }

    const togglePinned = () => {
        const desiredPinned = isPinned ? null : "left"
        api.applyColumnState({
            state: [{ colId, pinned: desiredPinned }],
            applyOrder: false,
        })
        handleMenuClose()
    }

    const moveLeft = () => {
        if (colIndex > 0) {
            api.moveColumns([colId], colIndex - 1)
        }
        handleMenuClose()
    }

    const moveRight = () => {
        if (colIndex < allColumns.length - 1) {
            api.moveColumns([colId], colIndex + 1)
        }
        handleMenuClose()
    }

    return (
        <div className="header-container">
            <span className="header-title">
                {isPinned && <img src={pin_icon} alt="Pinned Column" className="pin-icon" />}
                {customIcon && <img src={customIcon} alt="Menu Icon" className="pin-icon" />}
                {displayName}
            </span>
            <Tooltip title="Options">
                <IconButton size="small" onClick={handleMenuClick} className="options-button">
                    ⋮
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}>
                    {
                        currentCol?.getColDef()?.sortable && (
                            <>
                                <MenuItem onClick={sortAsc}>Sort: Ascending</MenuItem>
                                <MenuItem onClick={sortDesc}>Sort: Descending</MenuItem>
                            </>
                        )
                    }
                
                <MenuItem onClick={moveLeft} disabled={colIndex <= 0}>
                    Move Column to Left
                </MenuItem>
                <MenuItem onClick={moveRight} disabled={colIndex >= allColumns.length - 1}>
                    Move Column to Right
                </MenuItem>
                <MenuItem onClick={togglePinned}>{isPinned ? "Unpin Column" : "Pin Column"}</MenuItem>
            </Menu>
        </div>
    )
}

export default CustomHeader
